import type {
  Product,
  ProductDraft,
  ProductExportResponse,
  ProductListParams,
  ProductListResponse,
} from '../../../types/product'

// TODO: Implement Lightspeed product API gateway.
// Backend endpoint pattern: /lightspeed/stores/:storeId/products (unconfirmed — verify with backend team).
// Response shape is expected to be similar to Cova/Greenline but may differ in specification fields.
// Map response into the unified Product shape defined in src/types/product.ts.

export const lightspeedProductApis = {
  getList: (_storeId: string, _params: ProductListParams): Promise<ProductListResponse> => {
    return Promise.reject(new Error('Lightspeed product list: not yet implemented'))
  },

  getDetail: (_storeId: string, _productId: string): Promise<Product> => {
    return Promise.reject(new Error('Lightspeed product detail: not yet implemented'))
  },

  update: (_storeId: string, _productId: string, _data: Partial<ProductDraft>): Promise<Product> => {
    return Promise.reject(new Error('Lightspeed product update: not yet implemented'))
  },

  syncFromPos: (_storeId: string, _productId: string): Promise<Product> => {
    return Promise.reject(new Error('Lightspeed product POS sync: not yet implemented'))
  },

  bulkUpdate: (_storeId: string, _ids: string[], _action: string): Promise<void> => {
    return Promise.reject(new Error('Lightspeed product bulk update: not yet implemented'))
  },

  bulkAssign: (_storeId: string, _orgId: string, _productIds: string[], _payload: unknown): Promise<void> => {
    return Promise.reject(new Error('Lightspeed product bulk assign: not yet implemented'))
  },

  exportCsv: (_storeId: string, _params: ProductListParams): Promise<ProductExportResponse> => {
    return Promise.reject(new Error('Lightspeed product export: not yet implemented'))
  },
}
